"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fingerprintValidator = exports.fileIdSchema = exports.urlValidator = exports.urlSchema = exports.idValidator = exports.idNullableSchema = exports.idSchema = void 0;
var suretype_1 = require("suretype");
// NOTE
exports.idSchema = suretype_1.v.string().matches("^[A-Za-z0-9-_]+$").minLength(3).maxLength(600);
exports.idNullableSchema = suretype_1.v.anyOf([exports.idSchema, suretype_1.v.null()]);
exports.idValidator = (0, suretype_1.compile)(exports.idSchema);
exports.urlSchema = suretype_1.v.string().format("uri");
exports.urlValidator = (0, suretype_1.compile)(exports.urlSchema);
exports.fileIdSchema = suretype_1.v.string().minLength(1).maxLength(300);
exports.fingerprintValidator = (0, suretype_1.compile)(exports.fileIdSchema);
